import React from 'react'
import './Hpartner.css'
import target from './about/target.png'
function Hpartner() {
  return (
    <div className='hmaravisoonbdy'>


<div className='hmaravision'>


<div className='hmarachildvision' >

<img src={target} alt="" />

</div>

<div className='hmarachildvision'> 

<h1>
Medicee - Aapka Health Partner
</h1>

  <p>

  We are technology driven online solution for all your
medical needs.
Our team of medical experts will
accompany you at every step.
From finding the right doctor
and hospital booking doctor appointments,comparing
procedure costs to solving your health related queries.We
strive to continuously improve and develop new services to
empower and educate patients and their
families.
Medicee is here to ensure that the right
healthcare decisions are made.
  </p>
</div>

</div>


        
    </div>
  )
}

export default Hpartner